import { ZustandAPI } from './globalStore';

export type Notification = {
  message: string;
  timeout?: number;
};

export type NotificationStore = {
  notification?: Notification;
  showNotification: (notification: Notification) => void;
  clearNotification: () => void;
};

export const notificationStore = (args: ZustandAPI): NotificationStore => {
  const { set } = args;
  return {
    showNotification: (notification: Notification) => set(() => ({ notification })),
    clearNotification: () => set(() => ({ notification: null })),
  };
};
